var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNewMenu(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 4,
    height: 13,
    viewBox: "0 0 4 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 3.5C2.825 3.5 3.5 2.825 3.5 2C3.5 1.175 2.825 0.5 2 0.5C1.175 0.5 0.5 1.175 0.5 2C0.5 2.825 1.175 3.5 2 3.5ZM2 5C1.175 5 0.5 5.675 0.5 6.5C0.5 7.325 1.175 8 2 8C2.825 8 3.5 7.325 3.5 6.5C3.5 5.675 2.825 5 2 5ZM2 9.5C1.175 9.5 0.5 10.175 0.5 11C0.5 11.825 1.175 12.5 2 12.5C2.825 12.5 3.5 11.825 3.5 11C3.5 10.175 2.825 9.5 2 9.5Z",
    fill: "#97A0C0"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewMenu);
export default __webpack_public_path__ + "static/media/new-menu.49489a6c56e388c132e7c85f19259579.svg";
export { ForwardRef as ReactComponent };